import { Time } from '@funkey/shared/utils';

export const PAGINATION_SIZE = 12;
export const CACHE_DURATION = Time.seconds({ hours: 1 });

export type FilterType = 'categories' | 'subCategories' | 'regions';
